/** Hostnames allowed through the Instagram image proxy (SSRF guard). */
const ALLOWED_HOST_SUFFIXES = [
  ".cdninstagram.com",
  ".fbcdn.net",
  "instagram.com",
  "instagram.fna.fbcdn.net",
];

export function isProxiableInstagramImageUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:") return false;
    const host = parsed.hostname.toLowerCase();
    return ALLOWED_HOST_SUFFIXES.some(
      (suffix) => host === suffix.replace(/^\./, "") || host.endsWith(suffix)
    );
  } catch {
    return false;
  }
}

/** Serve Instagram CDN images via same-origin proxy to avoid CORP/CORS blocks. */
export function proxiedInstagramImageUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  const trimmed = url.trim();
  if (!isProxiableInstagramImageUrl(trimmed)) return trimmed;
  return `/api/proxy/instagram-image?url=${encodeURIComponent(trimmed)}`;
}
